<template>
  <div class="hero-card">
    <div class="hero-card__layout">
      <!-- Image Section -->
      <div class="hero-card__image-wrapper">
        <img :src="isDarkMode ? imageDark : imageLight" alt="Juan Lias" class="hero-image" />
      </div>

      <!-- Content Section -->
      <div class="hero-card__content">
        <h3 class="hero-card__name">Juan Lias</h3>
        <p class="hero-card__role">{{ $t('page.about.heroCard.role') }}</p>
        <p class="hero-card__bio">
          {{ $t('page.about.heroCard.bio') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import imageDark from '@/assets/images/juan-lias-front.webp'
import imageLight from '@/assets/images/juan-lias-front-light.webp'

// HeroCard component - Profile card for the bento grid
const isDarkMode = ref(true)

const updateTheme = () => {
  isDarkMode.value = document.documentElement.classList.contains('dark')
}

onMounted(() => {
  updateTheme()
  // Observer para detectar cambios de tema
  const observer = new MutationObserver(updateTheme)
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  })
  onUnmounted(() => observer.disconnect())
})
</script>

<style scoped>
.hero-card {
  @apply relative h-full overflow-hidden;
}

.hero-card__layout {
  @apply flex h-full w-full;
}

.hero-card__image-wrapper {
  @apply relative h-full flex-shrink-0;
  width: 10%; /* Responsive width */
  min-width: 120px;
  max-width: 200px;
}

.hero-image {
  @apply h-full w-full object-cover object-center;
}

.hero-card__content {
  @apply flex flex-col justify-center p-4 sm:p-6 pl-3 sm:pl-4 h-full flex-1 z-10;
  /* Prevent text overflow */
  min-width: 0;
}

.hero-card__name {
  @apply text-2xl sm:text-3xl md:text-4xl mb-1 sm:mb-2 font-madi;
  color: var(--color-text-primary);
  white-space: nowrap;
}

.hero-card__role {
  @apply text-xs sm:text-sm md:text-lg mb-2 sm:mb-3 font-medium;
  color: var(--color-electric-purple);
  line-height: 1.3;
}

.hero-card__bio {
  @apply text-xs sm:text-sm lg:text-base leading-relaxed;
  color: var(--color-text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 8; /* Increased line clamp to fit more text with smaller font */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Mobile adjustments */
@media (max-width: 640px) {
  .hero-card__image-wrapper {
    width: 90px; /* Slightly smaller image to give even more width to text */
    min-width: unset;
  }

  .hero-card__content {
    padding-right: 1rem;
  }
}
</style>
